/* =============================================================================
   Furniselan — product form (variant picker)
   ============================================================================= */
(function () {
  'use strict';

  var FS = window.FS, qs = FS.qs, qsa = FS.qsa, once = FS.once, T = FS.T, formatMoney = FS.formatMoney, reduceMotion = FS.reduceMotion;

  function initProductForm(ctx) {
    qsa('[data-product-form]', ctx).forEach(function (form) {
      if (!once(form, 'PForm')) return;
      var variantsEl = qs('[data-variants]', form);
      if (!variantsEl) return;
      var variants = [];
      try { variants = JSON.parse(variantsEl.textContent); } catch (e) { return; }

      var inputs = qsa('[data-option-select]', form);
      if (!inputs.length) return;
      var groups = {};
      inputs.forEach(function (input) { (groups[input.dataset.optionIndex] = groups[input.dataset.optionIndex] || []).push(input); });
      var groupIndexes = Object.keys(groups).sort(function (a, b) { return a - b; });

      var container = form.closest('.product, .quick-view');
      var idInput = qs('[name="id"]', form), price = qs('[data-product-price]', container || document), btn = qs('[type="submit"]', form);
      var inQuickView = !!form.closest('[data-quick-view-modal]');

      var singleMediaImg = inQuickView && container && qs('.quick-view__media img', container);

      function pickedValues() {
        var vals = {};
        groupIndexes.forEach(function (idx) {
          var checked = groups[idx].filter(function (r) { return r.checked; })[0];
          if (checked) vals[idx] = checked.value;
        });
        var pickerEl = container ? qs('[data-color-picker]', container) : qs('[data-color-picker]');
        if (pickerEl) {
          var cIdx = parseInt(pickerEl.getAttribute('data-option-index'), 10);
          if (!isNaN(cIdx)) {
            var activeColorEl = pickerEl.querySelector('[data-color-swatch].is-active, [data-color-swatch].on');
            var curColor = (activeColorEl && (activeColorEl.dataset.colorValue || activeColorEl.getAttribute('data-color-value'))) || pickerEl.dataset.selected;
            if (curColor) vals[cIdx] = curColor;
          }
        }
        return vals;
      }

      function filterGallery(opts) {
        var grouped = container ? qsa('[data-media-color]', container) : [];
        if (!grouped.length) return;
        var cleanOpts = opts.filter(Boolean).map(function (o) { return String(o).trim().toLowerCase(); });
        var visibleSlideCount = 0;
        grouped.forEach(function (el) {
          var c = (el.getAttribute('data-media-color') || '').trim().toLowerCase();
          var shouldHide = !!c && cleanOpts.every(function (o) { return c !== o; });
          el.hidden = shouldHide;
          if (!shouldHide && el.classList.contains('product__slide')) {
            visibleSlideCount++;
          }
        });
        if (visibleSlideCount === 0) {
          grouped.forEach(function (el) { el.hidden = false; });
        }
        var r = container && qs('.rail, [data-gallery-thumbs]', container);
        if (r) {
          r.scrollLeft = 0;
          var w = r.closest('.rail-wrap');
          if (w && w._updateEdges) w._updateEdges();
        }
      }

      function update() {
        groupIndexes.forEach(function (idx) {
          groups[idx].forEach(function (input) {
            var swatch = input.closest('.swatch');
            if (swatch) swatch.classList.toggle('is-selected', input.checked);
          });
        });
        var optsMap = pickedValues();
        var optKeys = Object.keys(optsMap);
        var v = variants.filter(function (x) {
          return optKeys.every(function (idx) {
            return optsMap[idx] == null || x.options[idx] === optsMap[idx];
          });
        })[0];
        if (!v) {
          if (btn) {
            btn.disabled = true;
            btn.setAttribute('disabled', 'disabled');
            btn.classList.add('disabled-btn');
            btn.textContent = T.strings.soldOut || 'Sold out';
          }
          return;
        }
        idInput.value = v.id;
        if (btn) {
          btn.disabled = !v.available;
          if (!v.available) {
            btn.setAttribute('disabled', 'disabled');
            btn.classList.add('disabled-btn');
          } else {
            btn.removeAttribute('disabled');
            btn.classList.remove('disabled-btn');
          }
          btn.textContent = v.available ? (T.strings.addToCart || 'Add to Cart') : (T.strings.soldOut || 'Sold out');
        }
        if (price) {
          var html = formatMoney(v.price);
          if (v.compare_at_price && v.compare_at_price > v.price) {
            var tagMult = 1.0;
            var pTags = (form.dataset.productTags || '').toLowerCase();
            if (pTags.indexOf('20off') > -1) tagMult = 1.25;
            else if (pTags.indexOf('15off') > -1) tagMult = 1.1764;
            else if (pTags.indexOf('10off') > -1) tagMult = 1.111;

            var regP = Math.round(v.price * tagMult);
            var pct = Math.round(((v.compare_at_price - regP) / v.compare_at_price) * 100);
            html += ' <s>' + formatMoney(v.compare_at_price) + '</s> <em>−' + pct + '%</em>';
          }
          price.innerHTML = html;
        }

        var codEl = (container || document).querySelector('[data-cod-available]');
        if (codEl) {
          var effectivePrice = v.price;
          var pTagsForCod = (form.dataset.productTags || '').toLowerCase();
          if (pTagsForCod.indexOf('20off') > -1) effectivePrice = Math.round(v.price * 0.8);
          else if (pTagsForCod.indexOf('15off') > -1) effectivePrice = Math.round(v.price * 0.85);
          else if (pTagsForCod.indexOf('10off') > -1) effectivePrice = Math.round(v.price * 0.9);

          var threshold = parseInt(codEl.getAttribute('data-cod-threshold'), 10) || 2300000;
          codEl.style.display = (effectivePrice <= threshold) ? '' : 'none';
        }
        groupIndexes.forEach(function (idx) {
          var label = qs('[data-option-value-label][data-option-index="' + idx + '"]', form);
          if (label && optsMap[idx] != null) label.textContent = optsMap[idx];
        });

        // 1. Update PDP title
        var pTitle = (container || document).querySelector('[data-product-title], .product__title');
        var colorVal = null;
        var picker = (container || document).querySelector('[data-color-picker]');
        var cIdx = picker ? parseInt(picker.getAttribute('data-option-index'), 10) : -1;
        if (cIdx > -1 && optsMap[cIdx]) {
          colorVal = optsMap[cIdx];
        } else if (v && v.options && v.options.length) {
          colorVal = (cIdx > -1) ? v.options[cIdx] : v.options[0];
        } else {
          var allOpts = Object.values(optsMap);
          if (allOpts.length > 0) colorVal = allOpts[0];
        }
        if (pTitle && colorVal) {
          var pColor = pTitle.querySelector('[data-title-color]');
          var pBase = pTitle.querySelector('[data-title-base]');
          var baseText = (pBase && pBase.textContent.trim()) || pTitle.getAttribute('data-title-base');
          if (pColor) pColor.textContent = ' - ' + colorVal;
          else if (baseText) pTitle.innerHTML = '<span data-title-base>' + baseText + '</span><span data-title-color> - ' + colorVal + '</span>';
        }

        // 2. Update quick view title if in quick view
        var qvTitle = (container || document).querySelector('.quick-view__title, [data-qv-title-base]');
        if (qvTitle && colorVal) {
          var qvColorEl = qs('[data-qv-color]', qvTitle);
          var qvBaseEl = qs('[data-qv-base]', qvTitle);
          var qvBase = (qvBaseEl && qvBaseEl.textContent.trim()) || qvTitle.getAttribute('data-qv-title-base');
          if (qvColorEl) qvColorEl.textContent = ' - ' + colorVal;
          else if (qvBase) qvTitle.innerHTML = '<span data-qv-base>' + qvBase + '</span><span data-qv-color> - ' + colorVal + '</span>';
        }

        var optsList = Object.keys(optsMap).map(function (k) { return optsMap[k]; });

        if (singleMediaImg) {
          if (v.featured_image && v.featured_image.src) {
            var sep = v.featured_image.src.indexOf('?') > -1 ? '&' : '?';
            singleMediaImg.removeAttribute('srcset');
            singleMediaImg.removeAttribute('sizes');
            singleMediaImg.src = v.featured_image.src + sep + 'width=900';
          }
        } else {
          filterGallery(optsList);
          var G = FS.ProductGallery, gallery = G && G.galleryFor(container);
          if (gallery) {
            if (v.featured_media) G.selectMedia(gallery, v.featured_media.id);
            var stillHidden = !qs('.product__slide.is-active:not([hidden])', gallery);
            if (!v.featured_media || stillHidden) G.selectFirstVisible(gallery);
            var r = qs('.rail, [data-gallery-thumbs]', gallery);
            if (r) {
              r.scrollLeft = 0;
              var w = r.closest('.rail-wrap');
              if (w && w._updateEdges) w._updateEdges();
            }
          } else {
            var media = v.featured_media && qs('[data-media-id="' + v.featured_media.id + '"]');
            if (media && !window._isInitialProductLoad && window.innerWidth <= 993) media.scrollIntoView({ block: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' });
          }
        }
        if (!inQuickView && history.replaceState) { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
         if (typeof window.updateProductDeliveryImage === 'function') {
          try { window.updateProductDeliveryImage(v.id); } catch(e){}
        }
        if (typeof window.checkProductDelivery === 'function') {
          try {
            var savedP = localStorage.getItem('fs-pincode');
            if (savedP && savedP.length === 6) window.checkProductDelivery(savedP);
          } catch(e){}
        }
        window.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
      }
      inputs.forEach(function (input) { input.addEventListener('change', update); });

      if (!singleMediaImg) {
        var pickerEl = container && qs('[data-color-picker]', container);
        var activeColorEl = pickerEl && qs('[data-color-swatch].is-active, [data-color-swatch].on', pickerEl);
        var picked = pickedValues();
        var cVal = (activeColorEl && activeColorEl.dataset.colorValue) || (pickerEl && pickerEl.dataset.selected);
        if (cVal && picked.indexOf(cVal) === -1) picked.push(cVal);
        filterGallery(picked);
        var G0 = FS.ProductGallery, g0 = G0 && G0.galleryFor(container);
        if (g0) {
          var alreadyActive = qs('.product__slide.is-active:not([hidden])', g0);
          if (!alreadyActive) G0.selectFirstVisible(g0);
        }
      }
    });
  }

  function initColorPicker(ctx) {
    qsa('[data-color-picker]', ctx).forEach(function (picker) {
      if (!once(picker, 'ColorPick')) return;
      var scope = picker.closest('.product, .quick-view') || document;
      var title = qs('[data-color-title]', picker) || (scope || document).querySelector('#finLbl, [data-color-title]');
      var dots = qsa('[data-color-swatch]', picker);

      function apply(value, scroll) {
        var valNorm = String(value || '').trim().toLowerCase();
        dots.forEach(function (d) {
          var dVal = (d.dataset.colorValue || d.getAttribute('data-color-value') || '').trim().toLowerCase();
          var isMatch = dVal === valNorm;
          d.classList.toggle('is-active', isMatch);
          d.classList.toggle('is-selected', isMatch);
          d.classList.toggle('on', isMatch);
        });
        var allTitles = (scope || document).querySelectorAll('#finLbl, [data-color-title]');
        allTitles.forEach(function (t) { t.textContent = value; });
        var pTitle = (scope || document).querySelector('[data-product-title], .product__title');
        if (pTitle && value) {
          var pColor = pTitle.querySelector('[data-title-color]');
          var pBase = pTitle.querySelector('[data-title-base]');
          var baseText = (pBase && pBase.textContent.trim()) || pTitle.getAttribute('data-title-base');
          if (pColor) pColor.textContent = ' - ' + value;
          else if (baseText) pTitle.innerHTML = '<span data-title-base>' + baseText + '</span><span data-title-color> - ' + value + '</span>';
        }
        var qvTitle = (scope || document).querySelector('.quick-view__title, [data-qv-title-base]');
        if (qvTitle && value) {
          var qvColor = qvTitle.querySelector('[data-qv-color]');
          var qvBase = qvTitle.querySelector('[data-qv-base]');
          var qvBaseText = (qvBase && qvBase.textContent.trim()) || qvTitle.getAttribute('data-qv-title-base');
          if (qvColor) qvColor.textContent = ' - ' + value;
          else if (qvBaseText) qvTitle.innerHTML = '<span data-qv-base>' + qvBaseText + '</span><span data-qv-color> - ' + value + '</span>';
        }
        var valNorm = String(value || '').trim().toLowerCase();
        var visibleSlideCount = 0;
        qsa('[data-media-color]', scope).forEach(function (el) {
          var c = (el.getAttribute('data-media-color') || '').trim().toLowerCase();
          var shouldHide = !!c && c !== valNorm;
          el.hidden = shouldHide;
          if (!shouldHide && el.classList.contains('product__slide')) {
            visibleSlideCount++;
          }
        });
        if (visibleSlideCount === 0) {
          qsa('[data-media-color]', scope).forEach(function (el) { el.hidden = false; });
        }
        var G = FS.ProductGallery, gallery = G && G.galleryFor(scope);
        if (gallery) {
          var visibleSlides = qsa('.product__slide:not([hidden])', gallery);
          var targetSlide = null;
          for (var i = 0; i < visibleSlides.length; i++) {
            var s = visibleSlides[i];
            if ((s.getAttribute('data-media-color') || '').trim().toLowerCase() === valNorm) {
              targetSlide = s;
              break;
            }
          }
          if (!targetSlide && visibleSlides.length) {
            targetSlide = visibleSlides[0];
          }
          if (targetSlide) {
            G.selectMedia(gallery, targetSlide.dataset.mediaId);
          } else {
            G.selectFirstVisible(gallery);
          }
          var r = qs('.rail, [data-gallery-thumbs]', gallery);
          if (r) {
            r.scrollLeft = 0;
            var w = r.closest('.rail-wrap');
            if (w && w._updateEdges) w._updateEdges();
          }
          if (scroll && G.notifyColorChange) {
            G.notifyColorChange(gallery, value, true);
          }
          return;
        }
        if (!scroll || window._isInitialProductLoad) return;
        var first = qsa('[data-media-id]', scope).filter(function (el) { return !el.hidden; })[0];
        if (first && window.innerWidth <= 993) first.scrollIntoView({ block: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      dots.forEach(function (d) {
        function preloadVariantImage() {
          var colVal = (d.dataset.colorValue || '').trim().toLowerCase();
          if (!colVal) return;
          var allS = qsa('.product__slide', scope);
          for (var i = 0; i < allS.length; i++) {
            if ((allS[i].getAttribute('data-media-color') || '').trim().toLowerCase() === colVal) {
              var img = qs('img', allS[i]);
              if (img) {
                var src = img.currentSrc || img.getAttribute('src');
                if (src) { var p = new Image(); p.src = src; }
              }
              break;
            }
          }
        }
        d.addEventListener('mouseenter', preloadVariantImage, { passive: true });
        d.addEventListener('touchstart', preloadVariantImage, { passive: true });

        d.addEventListener('click', function () {
          apply(d.dataset.colorValue, true);
          var vId = d.dataset.variantId;
          var variantsEl = (scope || document).querySelector('[data-variants]');
          var variants = [];
          if (variantsEl) {
            try { variants = JSON.parse(variantsEl.textContent); } catch (e) {}
          }
          var curInp = (scope || document).querySelector('input[name="id"]');
          var curVar = curInp && variants.find(function (v) { return String(v.id) === String(curInp.value); });
          var targetVariant = null;
          if (curVar && curVar.options) {
            var cIdx = parseInt(picker.getAttribute('data-option-index'), 10);
            if (isNaN(cIdx)) cIdx = 0;
            var wantedOptions = curVar.options.slice();
            wantedOptions[cIdx] = d.dataset.colorValue;
            targetVariant = variants.find(function (v) {
              return wantedOptions.every(function (val, idx) { return val == null || v.options[idx] === val; });
            });
          }
          if (!targetVariant && vId) {
            targetVariant = variants.find(function (v) { return String(v.id) === String(vId); });
          }
          if (!targetVariant && variants.length) {
            targetVariant = variants[0];
          }
          var finalId = targetVariant ? targetVariant.id : vId;
          if (finalId) {
            // IMPORTANT: Only update the id input within THIS product's scope.
            // Using document.querySelectorAll would also update Quick View or other
            // product forms currently in the DOM — causing wrong-product-in-cart bugs.
            var scopedIdInput = (scope === document ? document : (scope || document)).querySelector('input[name="id"]');
            if (scopedIdInput) scopedIdInput.value = finalId;
            if (history.replaceState) {
              var u = new URL(window.location.href);
              u.searchParams.set('variant', finalId);
              history.replaceState({}, '', u);
            }
            if (targetVariant && window.FS && typeof window.FS.updatePDPGalleryColor === 'function') {
              var mId = (targetVariant.featured_media && targetVariant.featured_media.id) || (targetVariant.featured_image && targetVariant.featured_image.id);
              window.FS.updatePDPGalleryColor(d.dataset.colorValue, mId);
            }
            window.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: targetVariant || { id: finalId } } }));
          }
        });
      });

      if (picker.dataset.selected) apply(picker.dataset.selected, false);
    });
  }

  window.FS.initProductForm = function (ctx) { initProductForm(ctx); initColorPicker(ctx); };
})();
